<template lang="pug">
.send-message-select-modal
  b-modal(ref="modal" size="lg" no-close-on-backdrop no-close-on-esc @ok="add" @cancel="cancel")
    template(v-slot:modal-title)
      span {{ title }}
      span.font-strong-color {{ titleMessage }}

    b-card-group.send-message-select-modal-card-group(deck)
      b-card.align-self-start(no-body)
        span.send-message-header(slot="header") グループ種別
        b-list-group.select-area(flush)
          
          b-list-group-item.resident(v-if="0 < targets.familyGroups.length" href="#"
            @click="selectSendMessageGroup(0)" :class="getGroupSelectedClass(0)") 宛先グループ（家族）
          b-list-group-item.resident(v-if="2 <= _planType && 0 < targets.otherUserGroupMemberGroups.length" href="#"
            @click="selectSendMessageGroup(1)" :class="getGroupSelectedClass(1)") 宛先グループ（施設関係者）
          b-list-group-item.resident(v-if="2 <= _planType && 0 < targets.residentGroups.length" href="#"
            @click="selectSendMessageGroup(2)" :class="getGroupSelectedClass(2)") 利用者グループ
          b-list-group-item.resident(v-if="2 <= _planType && 0 < targets.otherUserGroups.length" href="#"
            @click="selectSendMessageGroup(3)" :class="getGroupSelectedClass(3)") 施設関係者グループ

      b-card.align-self-start(no-body)
        .send-message-header(slot="header")
          div.mb-1 {{ groupTypeName }}
          .search-filter.d-flex.flex-row.justify-content-end.align-items-center(v-if="_groupType !== ''")
            b-input-group.search-filter-input-group.mr-1(size="md")
              b-input-group-prepend
                b-input-group-text.search-filter-icon
                  .search-icon
              b-form-input.search-filter-input(v-model="groupSearchWord" type="search"
                placeholder="グループの検索" @input="inputGroupSearchWord")
            HelpIcon.d-flex.justify-content-end.align-items-center(popoverId="family-search-filter-help" title="検索項目について")
              template(v-slot:text)
                div 検索項目は以下になります。
                div ・グループ名
        b-list-group.family-area(flush)
          b-list-group-item(v-if="group.show" v-for="group in viewTargets" :key="group.id" :disabled="group.memberCount < 1") 
            b-form-checkbox(v-model="group.isTarget")
              span {{ group.name }}（{{ group.memberCount }}人）

    div(slot="modal-footer" slot-scope="{ ok, cancel }")
      button.btn.modal-ok-btn(v-if="_checked" type="button" @click="ok()") OK
      button.btn.modal-ok-btn.disable(v-else type="button" disabled) OK
      button.btn.modal-cancel-btn(type="button" @click="cancel()") キャンセル
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { userStore } from "@/store/store";

import { GroupModel, OtherUserGroupTargetModel, ResidentGroupTargetModel, SendMessageGroupTargetModel } from "@/pc/containers/safetyConfirms/TargetSelectButton.vue";
import { PlanType } from "@/commons/services/Plans";
import HelpIcon from "@/pc/basics/HelpIcon.vue";

/**
 * ### グループ選択モーダル
 */
@Component({
  components: {
    HelpIcon
  }
})
export default class GroupSelectModal extends Vue {
  /** ダイアログタイトル */
  @Prop({ default: "宛先を選択してください。" })
  title!: string;
  /** タイトルメッセージ */
  @Prop({ default: undefined })
  titleMessage!: string;

  @Prop()
  groupType!: GroupType;

  /** グループ名検索ワード */
  groupSearchWord: string = "";

  /** 宛先対象リスト */
  targets: GroupModel = {
    familyGroups: [],
    otherUserGroupMemberGroups: [],
    residentGroups: [],
    otherUserGroups: []
  };
  /** 選択されたグループ種別名 */
  groupTypeName: string = "";
  /** 宛先候補の家族 */
  viewTargets: Array<SendMessageGroupTargetModel | ResidentGroupTargetModel | OtherUserGroupTargetModel> = [];

  get _planType(): PlanType {
    return userStore.facility.planType;
  }

  get _checked(): boolean {
    return (
      this.checkIsTarget(this.targets.familyGroups) ||
      this.checkIsTarget(this.targets.otherUserGroupMemberGroups) ||
      this.checkIsTarget(this.targets.residentGroups) ||
      this.checkIsTarget(this.targets.otherUserGroups)
    );
  }

  get _groupType(): GroupType {
    return this.groupType;
  }

  private checkIsTarget(items: Array<{ isTarget: boolean }>): boolean {
    for (let target of items) {
      if (target.isTarget == true) {
        return true;
      }
    }
    return false;
  }

  /**
   * 宛先グループ選択イベント処理
   */
  public selectSendMessageGroup(groupType: GroupType): void {
    this.$emit("update:groupType", groupType);
    switch (groupType) {
      // 宛先グループ（家族）
      case GroupType.FAMILY: {
        this.resetIsTargetProperty(this.targets.otherUserGroupMemberGroups);
        this.resetIsTargetProperty(this.targets.residentGroups);
        this.resetIsTargetProperty(this.targets.otherUserGroups);
        this.groupTypeName = "宛先グループ（家族）";
        this.viewTargets = this.targets.familyGroups;
        break;
      }
      // 宛先グループ（施設関係者）
      case GroupType.OTHER_USER: {
        this.resetIsTargetProperty(this.targets.familyGroups);
        this.resetIsTargetProperty(this.targets.residentGroups);
        this.resetIsTargetProperty(this.targets.otherUserGroups);
        this.groupTypeName = "宛先グループ（施設関係者）";
        this.viewTargets = this.targets.otherUserGroupMemberGroups;
        break;
      }
      // 利用者グループ
      case GroupType.RESIDENT_GROUP: {
        this.resetIsTargetProperty(this.targets.familyGroups);
        this.resetIsTargetProperty(this.targets.otherUserGroupMemberGroups);
        this.resetIsTargetProperty(this.targets.otherUserGroups);
        this.groupTypeName = "利用者グループ";
        this.viewTargets = this.targets.residentGroups;
        break;
      }
      // 施設関係者グループ
      case GroupType.OTHER_USER_GROUP: {
        this.resetIsTargetProperty(this.targets.familyGroups);
        this.resetIsTargetProperty(this.targets.otherUserGroupMemberGroups);
        this.resetIsTargetProperty(this.targets.residentGroups);
        this.groupTypeName = "施設関係者グループ";
        this.viewTargets = this.targets.otherUserGroups;
        break;
      }
    }
    return;
  }

  private resetIsTargetProperty(items: Array<{ isTarget: boolean }>): void {
    for (let target of items) {
      target.isTarget = false;
    }
    return;
  }

  public getGroupSelectedClass(type: GroupType): any {
    return {
      "selected-group": this.groupType === type ? true : false
    };
  }

  public inputGroupSearchWord(): void {
    for (const target of this.viewTargets) {
      if (!this.groupSearchWord) {
        target.show = true;
        continue;
      }

      const words: string[] = this.$filterUtil.createSearchWord(this.groupSearchWord);
      target.show = false;
      for (const word of words) {
        if (-1 < target.name.indexOf(word)) {
          target.show = true;
          break;
        }
      }
    }
    return;
  }

  /**
   * モーダル表示
   *
   * - 利用者は未選択の状態で表示する
   */
  public show(targets: GroupModel): void {
    this.targets = targets;
    this.viewTargets = [];
    this.groupTypeName = "　";
    this.$emit("update:groupType", GroupType.UNKNOWN);

    const modal: any = this.$refs.modal;
    if (modal) {
      modal.show();
    }

    return;
  }

  /**
   * OKボタン押下イベント
   *
   * - 親コンポーネントに入力情報を通知する
   */
  public add(): void {
    this.$emit("add", this.targets);
    return;
  }

  /**
   * キャンセルボタン押下イベント
   *
   * - 入力した内容を全て破棄する
   * - 親コンポーネントに通知する
   */
  public cancel(): void {
    this.resetIsTargetProperty(this.targets.familyGroups);
    this.resetIsTargetProperty(this.targets.otherUserGroupMemberGroups);
    this.resetIsTargetProperty(this.targets.residentGroups);
    this.resetIsTargetProperty(this.targets.otherUserGroups);

    this.$emit("cancel");

    return;
  }
}
export enum GroupType {
  // 画面バリデーションで使用するので、初期値としてい使用する場合は空文字を格納する
  UNKNOWN = "",
  FAMILY = 0,
  OTHER_USER = 1,
  RESIDENT_GROUP = 2,
  OTHER_USER_GROUP = 3
}
</script>

<style lang="scss">
@import "../../../styles/pc/_colors.scss";
@import "../../../styles/pc/_mixin.scss";

.font-strong-color {
  color: $font-strong-color;
}

.send-message-select-modal-card-group {
  .search-filter {
    .search-filter-input-group {
      .search-filter-icon {
        background-color: #fff !important;
        .search-icon {
          @include svg-icon("../../../assets/search.svg", $font-base-color, 20px, 20px);
        }
      }
      .search-filter-input {
        border-left: 0;
      }
    }
  }

  .select-area {
    position: relative;
    max-height: calc(100vh - 300px);
    overflow-y: auto;
  }
  .family-area {
    position: relative;
    max-height: calc(100vh - 300px);
    overflow-y: auto;
  }
  .selected-group {
    background-color: $btn-selected !important;
    color: $btn-font-selected !important;
  }
  .send-message-header {
    @include bold-font(16px);
  }
  .list-group-item.resident.list-group-item-action {
    &:hover {
      background-color: $list-hover;
    }
    &:focus {
      background-color: $list-selected;
    }
  }
}
</style>
